<template>
  <div class="mb-4" v-if="savedCards && savedCards.length > 0">
    <h5 class="mb-3">Cartões salvos</h5>
    <div class="saved-cards-list">
      <div 
        v-for="card in savedCards" 
        :key="card.id"
        class="saved-card-item mb-3"
        :class="{ 'selected': selectedCardId === card.id }"
        @click="selectCard(card)">
        <div class="card h-100 border" :class="{ 'border-primary shadow-sm': selectedCardId === card.id }">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-2">
                  <div class="card-brand-badge me-3" :class="getBrandBadgeClass(card.card_brand)">
                    <i class="fas fa-credit-card"></i>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 fw-bold">{{ card.nickname || getDefaultNickname(card) }}</h6>
                    <span class="badge badge-sm" :class="getBrandBadgeClass(card.card_brand)">
                      {{ getBrandName(card.card_brand) }}
                    </span>
                  </div>
                </div>
                <p class="text-muted mb-0 small font-monospace">{{ card.card_display }}</p>
                <div class="mt-2" v-if="selectedCardId === card.id">
                  <span class="text-success">
                    <i class="fas fa-check-circle"></i> Selecionado
                  </span>
                </div>
              </div>
              <div class="ms-3">
                <i class="fas fa-chevron-right text-muted" v-if="selectedCardId !== card.id"></i>
                <i class="fas fa-check-circle text-primary fs-4" v-else></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <button class="btn btn-outline-primary w-100" @click="showNewCardForm">
        <i class="fas fa-plus"></i> Adicionar novo cartão
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SavedCreditCardList',
  props: {
    savedCards: {
      type: Array,
      default: () => []
    },
    selectedCardId: {
      type: Number,
      default: null
    }
  },
  methods: {
    selectCard(card) {
      this.$emit('card-selected', card);
    },
    showNewCardForm() {
      this.$emit('show-new-card');
    },
    getDefaultNickname(card) {
      const brandName = this.getBrandName(card.card_brand);
      const lastDigits = card.card_display ? card.card_display.slice(-4) : '';
      return `Cartão ${brandName} final ${lastDigits}`;
    },
    getBrandName(brand) {
      const brands = {
        'visa': 'Visa',
        'mastercard': 'Mastercard',
        'elo': 'Elo',
        'amex': 'American Express',
        'hipercard': 'Hipercard'
      };
      return brands[brand?.toLowerCase()] || brand || 'Cartão';
    },
    getBrandBadgeClass(brand) {
      const brandLower = brand?.toLowerCase();
      const badgeMap = {
        'visa': 'bg-primary text-white',
        'mastercard': 'bg-danger text-white',
        'elo': 'bg-warning text-dark',
        'amex': 'bg-info text-white',
        'hipercard': 'bg-success text-white'
      };
      return badgeMap[brandLower] || 'bg-secondary text-white';
    }
  }
}
</script>

<style scoped>
.saved-cards-list {
  width: 100%;
}

.saved-card-item {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.saved-card-item:hover {
  transform: translateY(-2px);
}

.saved-card-item .card {
  transition: all 0.2s ease;
}

.saved-card-item:hover .card {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.saved-card-item.selected .card {
  background-color: #f8f9fa;
}

.card-brand-badge {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.badge-sm {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.font-monospace {
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
  font-size: 0.9rem;
}
</style>
